// components/SkillsPyramid.jsx
import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Functions } from "@mui/icons-material";
import { FaJava } from "react-icons/fa6";
import { DiJavascript } from "react-icons/di";
import { FaReact } from "react-icons/fa6";
import { FaNodeJs } from "react-icons/fa6";
import { SiMongodb } from "react-icons/si";
import { SiMui } from "react-icons/si";
import { SiPostgresql } from "react-icons/si";
import { SiAmazon } from "react-icons/si";
import { FaGithub } from "react-icons/fa6";
import { background, orange } from "../../theme/colors";
import { useEffect } from "react";
// import { keyframes } from "@mui/material/styles";

const skills = [
  { name: "Java", icon: <FaJava size={32} /> },
  { name: "JavaScript", icon: <DiJavascript size={32} /> },
  { name: "React", icon: <FaReact size={32} /> },
  { name: "Node", icon: <FaNodeJs size={32} /> },
  { name: "MongoDB", icon: <SiMongodb size={32} /> },
  { name: "MUI", icon: <SiMui size={32} /> },
  { name: "PostgreSQL", icon: <SiPostgresql size={32} /> },
  { name: "AWS", icon: <SiAmazon size={32} /> },
  { name: "GitHub", icon: <FaGithub size={32} /> },
  { name: "DSA", icon: <Functions fontSize="large" /> },
];

// Structure of pyramid rows (number of skills per row)
const pyramidStructure = [
  [0, 1, 2, 3], // First row
  [4, 5, 6], // Second row  
  [7, 8], // Third row
  [9], // Fourth row
];

const gridStructure = [
  [0, 2, 3], // First row
  [4, 5, 6], // Second row
  [7, 8, 9], // Third row
];

export default function SkillsPyramid() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [structure, setStructure] = useState(pyramidStructure);

  // const gradientMove = keyframes`
  //     0% { background-position: 0% 50%; }
  //     50% { background-position: 100% 50%; }
  //     100% { background-position: 0% 50%; }
  //   `;

  useEffect(() => {
    isMobile ? setStructure(gridStructure) : setStructure(pyramidStructure);
  }, [isMobile]);
  console.log("first");
  return (
    <Box
      id="skills"
      sx={{
        py: 8,
        textAlign: "center",
        background,
        // position: "relative",
        // background: `linear-gradient(-45deg, ${theme.palette.background.default}, ${theme.palette.background.paper}, ${theme.palette.secondary.dark}, ${theme.palette.primary.dark})`,
        // backgroundSize: "400% 400%",
        // animation: `${gradientMove} 15s ease infinite`,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          mb: 6,
          fontFamily: "Poppins, sans-serif",
        }}
      >
        My Skills
      </Typography>

      {structure.map((row, rowIndex) => (
        <Box
          key={rowIndex}
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: { xs: 2, md: 4 },
            mb: 3,
            flexWrap: "wrap",
          }}
        >
          {row.map((skillIndex) => {
            if (isMobile && skillIndex === 1) return <></>;
            const skill = skills[skillIndex];

            return (
              <Box
                key={skill.name}
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: 3,
                  boxShadow: 3,
                  p: 2,
                  minWidth: 100,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.25)",
                    "& .skill-icon": {
                      color: orange[500],
                    },
                    "& .skill-text": {
                      color: orange[500],
                    },
                  },
                }}
              >
                <Box className="skill-icon">
                  {skill.icon}
                </Box>
                <Typography
                  variant="body1"
                  className="skill-text"
                  sx={{
                    mt: 1,
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  {skill.name}
                </Typography>
              </Box>
            );
          })}
        </Box>
      ))}
    </Box>
  );
}
